
class allEleInvRedTemplateCtr {
    constructor($scope, $uibModalInstance, items1, invoiceOpenService, httpRequest, logger, globalFn) {
        httpRequest.get_dictByTypeArr(['ovat_red_reason', 'open_reason']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope = $.extend($scope, items1)
        $scope.invoiceList = items1
        $scope.param = {
            autoRestore: 0,
        }
        // 更新 合计 金额 税额
        function totalCalculation() {
            $scope.blueTotalAmt = 0
            $scope.blueTotalTaxamt = 0
            angular.forEach($scope.invoiceList, (item, index) => {
                $scope.blueTotalAmt = globalFn.Add($scope.blueTotalAmt, item.blueTotalAmt)
                $scope.blueTotalTaxamt = globalFn.Add($scope.blueTotalTaxamt, item.blueTotalTaxamt)
            })
        }
        totalCalculation()
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok(type) {
            $uibModalInstance.close({ autoRestore: $scope.param.autoRestore })
        }
    }
}

allEleInvRedTemplateCtr.$inject = ['$scope', '$uibModalInstance', 'items1', 'invoiceOpenService', 'httpRequest', 'logger', 'globalFn']
export default allEleInvRedTemplateCtr



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/allEleInvRedTemplateCtr.js